module.exports = __webpack_public_path__ + "67e12d801b84ca2e50e0d4c100bf8c37.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-store-links/sp-store-links.html
// module id = 1142
// module chunks = 0